import _ from 'underscore';
import ko from 'knockout';
import Backbone from 'backbone';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { withUiBlock } from '@bingads-webui/uiblocker';
import ViewModel from './bulk-edit-vm';
import template from './bulk-edit-template.pug';
import { bulkEditService } from '../hotel-center-service';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export class BulkEditView extends Backbone.View {
  initialize(options = {}) {
    this.options = _.defaults({}, options, {
      showPreview: true,
    });
    this.renderPreviewGrid = this.options.renderPreviewGrid || _.noop;
    this.updatePreviewResults = this.options.updatePreviewResults || _.noop;
    this.getBulkEditParams = this.options.getBulkEditParams || _.noop;
    this.blockerEl = this.options.blockerEl;
    this.viewModel = new ViewModel();
  }

  get events() {
    return {
      'click #Cancel': () => this.trigger('cancelClicked'),
      'click #Save': () => this.trigger('saveClicked'),
      'click #Preview': () => this.trigger('previewClicked'),
    };
  }

  progressCb(response) {
    this.viewModel.showProgress(true);
    this.viewModel.totalRowCount(response.TotalRowCount);
    this.viewModel.successRowCount(response.SuccessRowCount);
    this.viewModel.errorRowCount(response.ErrorRowCount);
  }

  preview() {
    const params = this.getBulkEditParams({ isPreview: true });

    this.viewModel.showProgress(false);
    // TODO: process error later
    bulkEditService.preview({
      params,
    })
      .finally(withUiBlock(this.blockerEl || this.$el.parent()))
      .then((data) => {
        this.showPreview(data);
      });
  }

  showPreview(data) {
    this.$('.preview-container').show();
    this.updatePreviewResults(data);
  }

  save() {
    bulkEditService.save(_.defaults({
      params: this.getBulkEditParams(),
      progressCB: _.bind(this.progressCb, this),
    }, _.pick(this.options, ['completeCB', 'failedCB'])))
      .finally(withUiBlock(this.blockerEl || this.$el.parent()));
  }

  render() {
    this.$el.html(template({
      showPreview: this.options.showPreview,
      saveText: this.options.saveText || i18n.getString('Button_Save'),
      cancelText: this.options.cancelText || i18n.getString('Button_Cancel'),
      previewText: this.options.previewText || i18n.getString('BulkEdit_PreviewChanges'),
    }));

    this.$('.preview-container').hide();

    ko.applyBindings(this.viewModel, this.el);

    this.renderPreviewGrid({
      el: this.$('.grid-table'),
    });

    return this;
  }
}
